import React, { useContext, useEffect } from "react";
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';
import EmailTemplatesTypes from "../../components/EmailTemplatesTypes";
import { UserContext } from '../../context/User';
import { useHistory } from 'react-router-dom';

const EmailTemplatesTypesPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();

  useEffect(() => {
   if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      <AdminHeader />
      <main>
        {role === "admin" && <EmailTemplatesTypes />}
      </main>
      <LoginFooter />
    </>
  );
}

export default EmailTemplatesTypesPage;